"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports._CompletedPart = {
    type: "structure",
    required: [],
    members: {
        ETag: {
            shape: {
                type: "string"
            }
        },
        PartNumber: {
            shape: {
                type: "integer"
            }
        }
    }
};
//# sourceMappingURL=_CompletedPart.js.map